<router-outlet></router-outlet>

<!--<ng-progress [color]="'#00857d'"-->
             <!--[speed]="700"-->
             <!--[showSpinner]="false"></ng-progress>-->
<upsc-element-blocker [isPageBlocker]="true"  *ngIf="isPageLoading || !isEndpointsReady"></upsc-element-blocker>
<!-- <div [userInactivity]="idleTimeout" (userInactivityCallback)="handleInactivityCallback()"></div> -->